import React from 'react';

export default ({
    name,
    className,
    even,
}) => {
    return <li className={`footer ${className}${even ? " even" : ""}`}>
        <div>
            <span>{name}</span>
        </div>
    </li>;
};